import { Controller } from "@hotwired/stimulus"

// Met à jour le libellé du solde dans la navbar après un achat simulé (paywall).

export default class extends Controller {
  static targets = ["label"]
  static values = {
    oneTemplate: String,
    otherTemplate: String,
    initialBalance: { type: Number, default: 0 }
  }

  connect() {
    this._onBalance = this._onBalance.bind(this)
    document.addEventListener("tokens:balance-updated", this._onBalance)
    this._render(this.initialBalanceValue)
  }

  disconnect() {
    document.removeEventListener("tokens:balance-updated", this._onBalance)
  }

  _onBalance(event) {
    const n = event.detail?.balance
    if (typeof n !== "number" || !Number.isFinite(n)) return
    this._render(n)
  }

  _render(n) {
    const tpl = n === 1 ? this.oneTemplateValue : this.otherTemplateValue
    this.labelTarget.textContent = tpl.replace(/%\{count\}/g, String(n))
    this._applyTone(n)
  }

  _applyTone(balance) {
    const base = "btn btn-ghost rounded-full bg-blue-100 "
    const tone =
      balance === 0 ? "text-red-400" : balance === 1 ? "text-orange-400" : "text-primary"
    this.element.className = base + tone
  }
}
